import * as React from "react";
import {useEffect} from "react";
import Container from '@mui/material/Container';
import {useLocation, useNavigate} from "react-router-dom";
import api from "../../utils/api";

const SetPayValidation = (props: any) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    
    const locationSearch = new URLSearchParams(location.search);
    const reservationTmpId = locationSearch.get('reservationTmpId');
    const familyId = encodeURIComponent(locationSearch.get('family_id') || '');
    const impUid = locationSearch.get('imp_uid');
    const merchantUid = locationSearch.get('merchant_uid');
    const imp_success = locationSearch.get('imp_success');
    const userName = locationSearch.get('userName');
    const wishDate = locationSearch.get('wishDate');
    
    // 포트원 결제 정상 처리
    if (imp_success === 'true') {
      // 임시 저장 상태인 예약 정보를 온전한 예약 상태로 저장
      api.post(`customer/api/v2/customers/${encodeURIComponent(localStorage.getItem("userCusID") || '')}/reservations/tmp/${reservationTmpId}/rebate/${impUid}/payments/${merchantUid}?family_id=${familyId}`, []).then(res => {
        if ( res.data.message.toString().toLowerCase() === "success" ||  res.data.success.toString().toLowerCase() === "true" ) {
          alert("결제가 완료되었습니다.");
          // 예약 완료 메세지 푸쉬 알림
          /* postMessage('PushAlarm', JSON.stringify({
            title: '듀얼헬스'
            , contents: `[건강 검진] ${userName}님 ${wishDate} 일자로 예약 접수 되었습니다.`
          })); */
          navigate('/MyPage/ReservationView');
        }else {
          throw Error(res.data.message);
        }
      }).catch(function (error) {
        console.log(error)
      });
    } else {
      // 임시 저장 상태인 예약 정보 삭제
      alert("결제 중 오류가 발생하였습니다.");
      api.delete(`customer/api/v2/customers/${encodeURIComponent(localStorage.getItem("userCusID") || '')}/reservations/tmp/${reservationTmpId}/rebate/payments/${merchantUid}`).then(res => {
        navigate('/reservation');
      }).catch(function (error) {
        console.log(error)
      });
    }
  }, []);
  
  const postMessage = (type: string, data: any) => {
    var win: any = window;
    win.ReactNativeWebView?.postMessage(JSON.stringify({ type, data }));
  };
  
  
  
  return (
    <Container>
    </Container>
  );
}

export default SetPayValidation;
